import { guideSteps } from '@/mocks/homeData';
import type { GuideStep } from '@/pages/home/types';

const steps = guideSteps as GuideStep[];

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-6xl">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-sm text-primary-600">
            <i className="ri-compass-3-line"></i>
            追热门指南
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">五步用好这份榜单</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            第一次来不用从头刷到尾。照着下面五个步骤走一遍，基本就能在几分钟内找到今天最值得看的内容。
          </p>
        </div>

        <ol className="relative mt-8 border-l border-background-300 pl-6 md:mt-10 md:pl-8">
          {steps.map((item, index) => (
            <li key={item.step} className={index === steps.length - 1 ? 'relative' : 'relative pb-8 md:pb-10'}>
              <span className="absolute -left-[31px] top-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 font-heading text-sm text-background-50 md:-left-[39px] md:w-10 md:h-10 md:text-base">
                {item.step}
              </span>
              <div className="rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5">
                <h3 className="text-sm text-foreground-950 md:text-base">{item.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-8 flex flex-col items-start gap-3 rounded-lg bg-accent-50 p-5 sm:flex-row sm:items-center sm:justify-between md:p-6">
          <div className="flex items-start gap-3">
            <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-lightbulb-flash-line text-xl"></i>
            </span>
            <div>
              <h3 className="text-sm text-foreground-950 md:text-base">小提示</h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                上榜内容通常在热度峰值过后才被大量看到，如果你不喜欢跟风，可以反过来关注榜单里名次刚下滑、但内容扎实的老片。
              </p>
            </div>
          </div>
          <a
            href="#ranking"
            className="inline-flex items-center gap-1.5 rounded-md bg-accent-600 px-4 py-2.5 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-accent-700"
          >
            回到榜单实操
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}